









































import type { CategoriaGlobalMarketplace, Page, Pageable } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FindCategoriaGlobalMarketplaceUseCase } from '@/usecases/marketplace/FindCategoriaGlobalMarketplaceUseCase'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'
import { Vue, Component, Watch, PropSync } from 'vue-property-decorator'
import { DataOptions } from 'vuetify'

@Component({
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeCategoriaGlobalMarketplace extends Vue {
	@PropSync('value', { default: null }) configuracaoGlobal!: CategoriaGlobalMarketplace
	categoriasGlobaisMarketplace: CategoriaGlobalMarketplace[] = []
	busca = ''
	buscandoNovosItens = false
	cancelToken: CancelTokenSource | null = null
	pagina: Page<CategoriaGlobalMarketplace> | null = null
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}
	
	findCategoriaGlobalMarketplaceUseCase =  new FindCategoriaGlobalMarketplaceUseCase()

	get configuracoesGlobaisFormatados() {

		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens) {
			const categoriasFiltradas = this.categoriasGlobaisMarketplace.filter(categoria => categoria.idExterno === this.configuracaoGlobal?.idExterno)

			if (categoriasFiltradas.length > 0) {
				return [
					...this.categoriasGlobaisMarketplace,
					...[{ tipo: 'buscar-mais' }],
				]
			} else {
				return [
					this.configuracaoGlobal,
					...this.categoriasGlobaisMarketplace,
					...[{ tipo: 'buscar-mais' }],
				]
			}
		}
		return this.categoriasGlobaisMarketplace
	}

	@Watch('busca')
	async onChangeBusca() {
		this.paginacao.page = 0

		this.categoriasGlobaisMarketplace = await this.buscar({
			...this.paginacao,
		})
	}

	async created() {
		this.categoriasGlobaisMarketplace = await this.buscar({
			...this.paginacao,
			page: 0,
		})
	}

	async buscarNovosItens() {
		this.buscandoNovosItens = true
		const categoriasNovas = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})

		this.categoriasGlobaisMarketplace = [
			...this.categoriasGlobaisMarketplace,
			...categoriasNovas,
		]
		this.buscandoNovosItens = false
	}

	async buscar(paginavel: Pageable) {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			if (this.configuracaoGlobal) this.busca = this.configuracaoGlobal.subCategoria

			this.pagina = await this.findCategoriaGlobalMarketplaceUseCase.findAll({
				busca: this.busca || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
			}, axiosConfig)
			
			this.paginacao.page = this.pagina?.number || 0

			return this.pagina?.content || []
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoNovosItens) this.buscarNovosItens()
	}

	filtrar(item: any, queryText, itemText) {
		if (item.tipo === 'header') return false

		const hasValue = val => (val ? val : '')
		const textLower = hasValue(itemText).toString().toLowerCase()
		const queryLower = hasValue(queryText).toString().toLowerCase()

		if (item.tipo === 'buscar-mais') return this.pagina && !this.pagina.last

		return textLower.includes(queryLower)
	}
}
